export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_ONLY_PADRAO_ACTION = 'onlyPadrao';
